import { Component, ElementRef, Inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../providers/login.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe, DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/providers/auth.service';
import { HomeService } from 'src/providers/home.service';

declare var $:any;

@Component({
  selector: 'app-top-bar',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent {

}

@Component({
  selector: 'login-dialog',
  templateUrl: 'login_modal.html',
})
export class LoginModal {
  toggle = true;
  toggle1 = true;
  toggle2 = true;
  toggle3 = true;
  status = 'Enable';
  progressPercent: any = 0;
  url = "http://localhost:4200/https://media.iquanta.in/ui_images/icons/usericon.png"
  public isActive: boolean = true;
  selected = "gender";
  // @ViewChild('loginRef', { static: false }) loginElement!: ElementRef;
  loginwithotp: boolean = false;
  show: boolean = true;
  otpFlag: boolean = false;
  newUserFlag: boolean = false;
  otp: any;
  registerForm: FormGroup;
  auth2: any;
  otpForm: FormGroup;
  idForm!: FormGroup
  show2: boolean = false
  show1: boolean = false;
  show3: boolean = false;
  show4: boolean = false;
  show5: boolean = false;
  mobile_no: any;
  url1: any;
  profileForm!: FormGroup;
  profileImage: any;
  structureFile: any;
  // profileInformationForm: FormGroup;
  gmailUser: any;

  categoryExams: any[] = [
    {
      id: 1, subtext: '', category: 'MBA Exam', value: 'MBA',
      exams: ['CAT', 'NMAT', 'SNAP', 'XAT', 'IIFT', 'MICAT', 'TISSNET', 'CMAT', 'MAH CET', 'PGDBA']
    },
    {
      id: 2, subtext: '', category: 'IPMAT | CUET | CLAT', value: 'After 12th',
      exams: [
        'IPMAT INDORE',
        'IPMAT ROHTAK',
        'CUET UG',
        'JIPMAT',
        'NPAT',
        'SET',
        'IPUCET BBA',
        'CLAT',
        'AILET'
      ]
    },
    {
      id: 3, subtext: '', category: 'IIT JEE', value: 'Engineering',
      exams: ['JEE Main', 'JEE Advanced', 'BITSAT',
        'WBJEE']
    },
    {
      id: 4, subtext: '', category: 'NEET', value: 'Medical',
      exams: ['NEET']
    },
    {
      id: 5, subtext: 'Study Abroad', category: 'GMAT Exam', value: 'Study Abroad',
      exams: ['GMAT', 'GRE', 'IELTS', 'TOEFL', 'PTE', 'SAT']
    },

    {
      id: 6, subtext: 'Banking SSC', category: 'Govt. Exams', value: 'SSC',
      exams: ['SBI PO',
        'IBPS PO',
        'SSC',
        'UPSC',
        'NDA',
        'CDS',
        'EPFO',
        'STATE PSC',
        'RAILWAY']
    }
  ]

  fbInit: any;
  imageObj: any;

  cityList: any[] = [];
  routeurl: any
  loginWithId: boolean = false;
  pageUrl:any;

  constructor(public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public dashboardService: HomeService,
    public dialogRef: MatDialogRef<LoginModal>, public router: Router,
    public datePipe: DatePipe, public loginService: LoginService,
    public elementRef: ElementRef, public loginServ: LoginService, public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public deviceService: DeviceDetectorService, public cdr: ChangeDetectorRef, private zone: NgZone,
    public spinnerService: NgxSpinnerService, @Inject(DOCUMENT) public dom: any,
    public authServiceInternal: AuthService) {
    this.registerForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      phone_no: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      gender: [''],
      dob: [''],
      city: ['', Validators.required]
    })

this.pageUrl = this.sessionStorage.getItem('pageUrl')

    this.otpForm = this.formBuilder.group({
      phone_no: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      otp: [''],
    })

    this.idForm = this.formBuilder.group({
      user_id: ['', Validators.required],
      password: ['', Validators.required]
    })

    this.getImage()
    this.getAddressIP()
    this.getCities()

    // if(this.data.exams){
    //   this.categoryExams = this.data.exams
    // }else {
    if (this.dom.URL.includes('iit-jee-coaching') || this.dom.URL.includes('jee-crash-course') ||
      this.dom.URL.includes('jee-study-material') || this.dom.URL.includes('jee-mock-test') ||
      this.dom.URL.includes('jee-main-percentile-calculator') || this.dom.URL.includes('bitsat-crash-course')
      || this.dom.URL.includes('bitsat-mock-test')) {
      this.categoryExams = [
        {
          id: 3, subtext: '', category: 'IIT JEE', value: 'Engineering',
          exams: ['JEE Main', 'JEE Advanced', 'BITSAT',
            'WBJEE']
        },
      ]
    } else if (this.dom.URL.includes('neet-coaching') || this.dom.URL.includes('neet-mock-test') || this.dom.URL.includes('neet-study-material')) {
      this.categoryExams = [
        {
          id: 4, subtext: '', category: 'NEET', value: 'Medical',
          exams: ['NEET']
        },
      ]
    } else if (this.dom.URL.includes('gmat') || this.dom.URL.includes('study-abroad') || this.dom.URL.includes('gmat-course-details') ||
      this.dom.URL.includes('gmat-entire-aplication') || this.dom.URL.includes('gmat-interview') || this.dom.URL.includes('ielts')) {
      this.categoryExams = [
        {
          id: 5, subtext: 'Study Abroad', category: 'GMAT Exam', value: 'Study Abroad',
          exams: ['GMAT', 'GRE', 'IELTS', 'TOEFL', 'PTE', 'SAT']
        },
      ]
    } else if (this.dom.URL.includes('govt-exams')) {
      this.categoryExams = [
        {
          id: 6, subtext: 'Banking SSC', category: 'Govt. Exams', value: 'SSC',
          exams: ['SBI PO',
            'IBPS PO',
            'SSC',
            'UPSC',
            'NDA',
            'CDS',
            'EPFO',
            'STATE PSC',
            'RAILWAY']
        }
      ]
    } else if (this.dom.URL.includes('banking-online-course')) {
      this.categoryExams = [
        {
          id: 6, subtext: 'Banking SSC', category: 'Govt. Exams', value: 'SSC',
          exams: ['SBI PO',
            'IBPS PO',
            'SSC',
            'UPSC',
            'NDA',
            'CDS',
            'EPFO',
            'STATE PSC',
            'RAILWAY']
        }
      ]
    } else if (this.dom.URL.includes('cuet') || this.dom.URL.includes('cuet-results') || this.dom.URL.includes('cuet-mock-test') ||
      this.dom.URL.includes('test/cuet-previous-papers') || this.dom.URL.includes('cuet-pg-mock-test') || this.dom.URL.includes('cuet-college-predictor') ||
      this.dom.URL.includes('clat-coaching') || this.dom.URL.includes('clat-mock-test') || this.dom.URL.includes('clat-scholarship-test') ||
      this.dom.URL.includes('best-clat-books') || this.dom.URL.includes('free-clat-study-material') || this.dom.URL.includes('test-clat-all-indian-mock') ||
      this.dom.URL.includes('test/clat-previous-papers') || this.dom.URL.includes('ipmat') || this.dom.URL.includes('ipmat-mock-test') ||
      this.dom.URL.includes('ipmat-results') || this.dom.URL.includes('best-ipmat-books') || this.dom.URL.includes('free-ipmat-study-material') ||
      this.dom.URL.includes('test/ipmat-previous-papers')) {
      this.categoryExams = [
        {
          id: 2, subtext: '', category: 'IPMAT | CUET | CLAT', value: 'After 12th',
          exams: [
            'IPMAT INDORE',
            'IPMAT ROHTAK',
            'CUET UG',
            'JIPMAT',
            'NPAT',
            'SET',
            'IPUCET BBA',
            'CLAT',
            'AILET'
          ]
        },
      ]
    } else if (this.dom.URL.includes('cat-2025') || this.dom.URL.includes('cat-crash-course') || this.dom.URL.includes('cat-previous-papers') ||
      this.dom.URL.includes('cat-mock-test') || this.dom.URL.includes('cat-before-cat') || this.dom.URL.includes('iim-call-predictor') ||
      this.dom.URL.includes('top-mba-colleges') || this.dom.URL.includes('prepare-mba') || this.dom.URL.includes('check-cat-result') ||
      this.dom.URL.includes('best-cat-books') || this.dom.URL.includes('cat-scholarship-test') || this.dom.URL.includes('cat-results') ||
      this.dom.URL.includes('aagman') || this.dom.URL.includes('cat-carnival') || this.dom.URL.includes('cat-offline-coaching') ||
      this.dom.URL.includes('cat-2026') || this.dom.URL.includes('free-cat-study-material') || this.dom.URL.includes('cat-lrdi-inception') ||
      this.dom.URL.includes('iim-calls') || this.dom.URL.includes('sop-for-iim') || this.dom.URL.includes('cat-score-vs-percentile-tool') || this.dom.URL.includes('top-colleges') ||
      this.dom.URL.includes('mba-interview-call') || this.dom.URL.includes('cat-mahakumbh') || this.dom.URL.includes('cat-2024-last-mile') ||
      this.dom.URL.includes('bschools') || this.dom.URL.includes('nmat-online-coaching') || this.dom.URL.includes('nmat-mock-test') ||
      this.dom.URL.includes('snap-online-coaching') || this.dom.URL.includes('snap-mock-test') || this.dom.URL.includes('test/nmat-previous-papers') ||
      this.dom.URL.includes('test/snap-previous-papers') || this.dom.URL.includes('xat-coaching') || this.dom.URL.includes('xat-mock-test') ||
      this.dom.URL.includes('xat-score-calculator') || this.dom.URL.includes('cmat-mock-test') || this.dom.URL.includes('test/cmat-previous-papers') ||
      this.dom.URL.includes('mahcet-mock-test')) {
      this.categoryExams = [
        {
          id: 1, subtext: '', category: 'MBA Exam', value: 'MBA',
          exams: ['CAT', 'NMAT', 'SNAP', 'XAT', 'IIFT', 'MICAT', 'TISSNET', 'CMAT', 'MHCET', 'PGDBA']
        },
      ]
    }
    // }

    // this.authService.authState.subscribe((user) => {
    //   // this.user = user;
    //   // this.loggedIn = (user != null);
    //   console.log(user)
    // });
  }

  ngOnInit() {
    this.routeurl = document.URL.split('/')[document.URL.split('/').length - 1];
    if (this.routeurl == 'jaipur') {
      this.loginWithId = true
    }

  }

  ngAfterViewInit(){
// setTimeout(() => {
//       $('#exampleFormControlSelect2').selectpicker('refresh');
//     });
  }

  isNumber(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  ipAddress: any;
  getAddressIP() {
    this.loginService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }



  gotolink(val: any) {
    window.open(val, '_blank')
  }

  getImage() {
    this.loginService.getLoginImage().subscribe(res => {
      if (res.length > 0) {
        this.imageObj = res[0]
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  questions() {
    this.dialogRef.close('yes');
  }


  googleLoginOptions = {
    scope: 'profile email'
  }
  googleUserData: any
  googleSDK() {

    this.authServiceInternal.login()
    this.authServiceInternal.user.subscribe(reqObj => {
      if (reqObj) {
        let reqData = {
          id: reqObj.sub,
          username: reqObj.name.split(' ').join() + '-' + reqObj.sub,
          email: reqObj.email,
          gmail_pic: reqObj.picture
        }
        this.loginService.gmail_login(reqData).subscribe(res => {
          if (res.success) {
            this.sessionStorage.setItem('usertoken', res.key);
            this.saveLoginInfo(res.key)
            this.dialogRef.close(reqData)
          } else {
            this.zone.run(() => {
              this.registerForm.controls['email'].setValue(reqData.email)
              this.registerForm.controls['first_name'].setValue(reqObj.name);
              this.structureFile = reqObj.google_pic;
              this.newUserFlag = true;
              this.show = false;
            });
            // this.cdr.detectChanges()

          }
        })
      }
    })

  }

  backStep1() {
    this.show = false
    this.show1 = true
  }
  backStep2() {
    this.show = true;
    this.show2 = false;
  }
  backStep3() {
    this.show3 = false;
    this.show2 = true;
  }
  backStep4() {
    this.show3 = true;
    this.show4 = false;
  }

  nextStep() {
    if (this.registerForm.valid) {
      this.show3 = true;
      this.newUserFlag = false;
    } else {
      if (this.registerForm.controls['first_name'].hasError('required')) {
        this.matSnackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      } else if (this.registerForm.controls['email'].hasError('pattern')) {
        this.matSnackBar.open('Email is invalid', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      } else if (this.registerForm.controls['email'].hasError('required')) {
        this.matSnackBar.open('Email is Required', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      } else if (this.registerForm.controls['phone_no'].hasError('required')) {
        this.matSnackBar.open('Mobile Number is Required', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      } else if (this.registerForm.controls['phone_no'].hasError('pattern')) {
        this.matSnackBar.open('Mobile Number is Invalid', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      } else {
        this.matSnackBar.open('Fill the Details to continue', 'OK', {
          verticalPosition: 'top',
          duration: 5000,
          panelClass: 'snack-error'
        })
      }
    }
  }
  nextStep2() {
    if (this.selectedCategory) {
      this.show3 = false;
      this.show4 = true;
    } else {
      this.matSnackBar.open('Select Exam Category', 'OK', {
        verticalPosition: 'top',
        duration: 5000,
        panelClass: 'snack-error'
      })
    }
  }

  getCities() {
    this.loginService.getIndianCities().subscribe(res => {
      if (res) {
        this.cityList = res;
      }
    })
  }

  filter(event: any) {
    if (this.registerForm.value.city) {
      const filterValue = this.registerForm.value.city.toLowerCase();
      this.cityList = this.cityList.filter(option => option.toLowerCase().includes(filterValue));
    } else {
      this.getCities()
    }

  }


  onFileChanged(ev: any) {
    this.profileImage = ev.target.files[0];
    this.readThis(ev.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      this.structureFile = myReader.result;
    }
    myReader.readAsDataURL(file);
  }

  loginId() {
    this.show5 = true
    this.show1 = false
  }

  logiotp() {
    this.show = true
    this.show1 = false
  }

  loginotponsubmit1() {
    this.errorMsg = '';
    this.otpForm.controls['phone_no'].setValue(JSON.stringify(this.otpForm.value.phone_no).trim().replaceAll(' ', ''))
    if (this.otpForm.valid) {
      this.loginServ.loginwithotop(this.otpForm.value.phone_no, this.ipAddress).subscribe(res => {
        if (res.success) {
          this.otpFlag = true;
        } else {
          this.errorMsg = res.data;
        }
      }, err => {
        this.errorMsg = err.error.data
      })
    } else {
      this.errorMsg = 'Please enter valid Phone Number';
    }
  }

  errorMsg: any;
  loginotponsubmit() {
    this.errorMsg = '';
    this.otpForm.controls['phone_no'].setValue(this.otpForm.value.phone_no.trim().replaceAll(' ', ''))
    if (this.otpForm.valid) {
      this.loginServ.loginwithotop(this.otpForm.value.phone_no, this.ipAddress).subscribe(res => {
        if (res.success) {
          this.otpFlag = true;
        } else {
          this.errorMsg = res.data;
        }
      }, err => {
        this.errorMsg = err.error.data
      })
    } else {
      this.errorMsg = 'Please enter valid Phone Number';
    }
  }

  saveLoginInfo(status: any) {
    let page = document.URL.split('/')[document.URL.split('/').length - 1]
    let reqObj = {
      ip_address: this.ipAddress,
      location: '',
      status: true,
      device: this.deviceService.isMobile() ? 'Mobile' : 'Desktop',
      page_location: page ? page : 'Home'
    }
    this.loginService.saveLoginInfo(reqObj, status).subscribe(res => {
      // location.reload()
    })
  }

  userData: any
  addInternalCRMLead(res: any) {
    let medium: any;
    let source: any;
    let campaign: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
        if (item.includes('utm_source')) {
          source = item.split('=')[1]
        }
        if (item.includes('utm_campaign')) {
          campaign = item.split('=')[1]
        }
      })
    }
    let leadPriority: any = 'Platinum';
    if (this.dom.URL.includes('cat-before-cat') || this.dom.URL.includes('iim-call-predictor') || this.dom.URL.includes('top-mba-colleges') || this.dom.URL.includes('aagman')
      || this.dom.URL.includes('cat-carnival') || this.dom.URL.includes('cat-offline-coaching') || this.dom.URL.includes('free-cat-study-material') || this.dom.URL.includes('iim-calls') || this.dom.URL.includes('sop-for-iim')
      || this.dom.URL.includes('top-colleges') || this.dom.URL.includes('bschools') || (this.dom.URL.includes('test') && this.dom.URL.includes('previous-papers')) || this.dom.URL.includes('xat-score-calculator')) {
      leadPriority = 'Silver'
    } else if (this.dom.URL.includes('cat-2024-last-mile') || this.dom.URL.includes('cat-mahakumbh') || this.dom.URL.includes('mba-interview-call')
      || this.dom.URL.includes('cat-score-vs-percentile-tool') || this.dom.URL.includes('cat-lrdi-inception') || this.dom.URL.includes('cat-results')
      || this.dom.URL.includes('cat-scholarship-test') || this.dom.URL.includes('check-cat-result') || this.dom.URL.includes('prepare-mba')) {
      leadPriority = 'Gold'
    }
    let page = this.router.url.split('?')[0]
    let reqObj = {
      "name": this.registerForm.value.first_name,
      "firstName": this.registerForm.value.first_name,
      "phone": this.registerForm.value.phone_no,
      "email": this.registerForm.value.email,
      "countryCode": '91',
      "source": "Website",
      "medium": this.data ? this.data.page ? 'Signup - ' + this.data.page : this.data : 'Signup',
      "campaign": (this.data ? this.data.campaign ? this.data.campaign : 'Home' : this.pageUrl ? this.pageUrl : page ? page.split('/')[page.split('/').length - 1] : 'Home'),
      "pageLocation": this.dom.URL,
     "orgId": this.dom.URL.includes('/offline-center/jamshedpur') ? "68380db410fb67f12376090d" : "66dec57ce200bc89284602d6",
        "uid": this.dom.URL.includes('/offline-center/jamshedpur') ? "68380db510fb67f123760933" : '66dec57ce200bc89284602d6',
      "userId": this.userData ? this.userData.id : 9999,
      "registrationDate": new Date().valueOf(),
      "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.router.url,
      "registrationDevice": this.deviceService.deviceType,
      "customFields": {
        "exam": this.selectedSubCat.join(','),
        "examCategory": this.selectedCategory.value,
        "examTargetYear": '2025',
        "leadPriority": this.data ? this.data.priority ? this.data.priority : leadPriority : leadPriority,
      },
      "ipAddress": this.sessionStorage.getItem('ipAddress'),
      dataSource: [
        {
          utmSource: source,
          utmMedium: medium,
          utmCampaign: campaign,
          utmAdContent: "",
          "pageLocation": this.dom.URL,
          "source": "Website",
          "medium": this.data ? this.data.page ? this.data.page ? 'Signup - ' + this.data.page : this.data : 'Signup' : 'Signup',
          "campaign": (this.data ? this.data.campaign ? this.data.campaign : 'Home' : page ? page.split('/')[page.split('/').length - 1] : 'Home'),
          adContent: "",
          "ipAddress": this.sessionStorage.getItem('ipAddress'),
          browser: this.deviceService.browser,
          browser_version: this.deviceService.browser_version,
          device: this.deviceService.device,
          deviceType: this.deviceService.deviceType,
          orientation: this.deviceService.orientation,
          os: this.deviceService.os,
          os_version: this.deviceService.os_version,
          platformId: this.deviceService['platformId'],
          ua: this.deviceService.ua,
          userAgent: this.deviceService.userAgent
        },
      ],
    }
    this.dashboardService.addCRMLead(reqObj).subscribe(res1 => {
      // if (res1.success) {
      this.spinnerService.hide()
      this.dialogRef.close(res)
      // }
    }, err => {
      this.spinnerService.hide()
      this.callBackLead(reqObj, res)
      // this.dialogRef.close(res)
    })
  }

  callBackLead(reqObj: any, user: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.dialogRef.close(user)
    })
  }

  verifyOtp() {
    this.errorMsg = '';
    if (this.otpForm.value.otp) {
      let reqObj = {
        phone_no: this.otpForm.value.phone_no,
        otp: this.otpForm.value.otp,
        ip: this.ipAddress
      }
      this.loginServ.verifywithOTP(reqObj).subscribe(res => {
        if (res.success) {
          if (res.token) {
            console.log('sdfsdfsdf')
            this.sessionStorage.setItem('usertoken', res.token);
            this.saveLoginInfo(res.token)
            this.dialogRef.close(res)
          } else {
           
            this.registerForm.controls['phone_no'].setValue(this.otpForm.value.phone_no)
            this.newUserFlag = true;
          }
          this.otpFlag = false;
          this.show = false
        } else {
          this.errorMsg = res.data;
        }
      })
    } else {
      this.errorMsg = 'Please enter OTP';
    }
  }

  verifyOtp1() {
    this.errorMsg = '';
    if (this.otpForm.value.otp) {
      let reqObj = {
        phone_no: this.otpForm.value.phone_no,
        otp: JSON.stringify(this.otpForm.value.otp),
        ip: this.ipAddress
      }
      this.loginServ.verifywithOTP(reqObj).subscribe(res => {
        if (res.success) {
          if (res.token) {
            this.sessionStorage.setItem('usertoken', res.token);
            this.saveLoginInfo(res.token)
            this.dialogRef.close(res)
          } else {
            this.registerForm.controls['phone_no'].setValue(this.otpForm.value.phone_no)
            this.newUserFlag = true;
          }
          this.otpFlag = false;
          this.show = false
        } else {
          this.errorMsg = res.data;
        }
      })
    } else {
      this.errorMsg = 'Please enter OTP';
    }
  }

  loginWithUserId() {
    this.errorMsg = '';
    if (this.idForm.valid) {
      this.loginServ.loginWithUserid(this.idForm.value).subscribe((res: any) => {
        if (res.success) {
          this.sessionStorage.setItem('usertoken', res.token);
          this.saveLoginInfo(res.token)
          this.dialogRef.close(res)
        } else {
          this.errorMsg = res.data;
        }
      }, error => {
        this.errorMsg = error.error.data
      })
    } else {
      this.errorMsg = 'Please enter valid Data'
    }
  }

  addNPF() {
    let page = document.URL.split('/')[document.URL.split('/').length - 1]
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.registerForm.value.first_name,
      "field_last_name": this.registerForm.value.first_name,
      "country_dial_code": "+91",
      "mobile": this.registerForm.value.phone_no,
      "email": this.registerForm.value.email,
      "field_gender": this.registerForm.value.gender,
      "field_date_of_birth": this.datePipe.transform(this.registerForm.value.dob, 'dd/MM/yyyy'),
      "field_exam_category": this.selectedCategory.value,
      "field_exam": this.selectedSubCat,
      "field_course_year": "",
      "field_current_date": this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      "source": "Website",
      "medium": 'Signup',
      "field_lead_priority": 'Gold',
      "field_website_page": page ? page : 'Home'
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {

    })

  }
  selectedCategory: any;
  selectCat(cat: any) {
    this.selectedCategory = cat;
  }
  selectedSubCat: any[] = []
  selectSubCat(val: any) {
    if (this.selectedSubCat.includes(val)) {
      let index = this.selectedSubCat.indexOf(val)
      this.selectedSubCat.splice(index, 1)
    } else {
      this.selectedSubCat.push(val)
    }
  }

  singupError: any;

  register() {
    this.singupError = '';
    if (this.registerForm.valid && this.selectedSubCat.length > 0) {
      this.spinnerService.show()
      let formData = new FormData()
      let date: any = this.datePipe.transform(this.registerForm.value.dob, 'yyyy-MM-dd')
      formData.append('phone_no', this.registerForm.value.phone_no)
      formData.append('username', this.registerForm.value.first_name.replaceAll(' ', '-') + '-' + this.registerForm.value.phone_no)
      formData.append('email', this.registerForm.value.email)
      formData.append('first_name', this.registerForm.value.first_name)
      formData.append('profile_pic', this.profileImage ? this.profileImage : '')
      formData.append('gender', this.registerForm.value.gender)
      formData.append('city', this.registerForm.value.city)
      if (date) {
        formData.append('dob', date)
      }
      formData.append('exam_category', this.selectedCategory.value)
      formData.append('exam', JSON.stringify(this.selectedSubCat))
      if (this.gmailUser) {
        formData.append('gmail_id', this.gmailUser.id)
        formData.append('gmail_pic', this.gmailUser.google_pic)
      }
      this.loginServ.userRegister(formData).subscribe(res => {
        if (res.success) {
          this.spinnerService.hide()
          this.progressPercent = 100;
          this.userData = res.data;
          this.addNPF()
          // if (this.data) {
          this.addInternalCRMLead(res)
          // }
          this.sessionStorage.setItem('usertoken', res.Token);
          this.sessionStorage.setItem('userData', JSON.stringify(res.data));
          this.saveLoginInfo(res.Token)

        } else {
          this.spinnerService.hide()
          this.show3 = false;
          this.show4 = false;
          this.newUserFlag = true;
          this.singupError = res.data;
        }
      }, err => {
        console.log(err)
        this.spinnerService.hide()
        if (err.error.username) {
          this.show3 = false;
          this.show4 = false;
          this.newUserFlag = true;
          this.singupError = err.error.username[0];
        } else if (err.error.phone_no) {
          this.show3 = false;
          this.show4 = false;
          this.newUserFlag = true;
          this.singupError = err.error.phone_no[0];
        } else if (err.error.email) {
          this.show3 = false;
          this.show4 = false;
          this.newUserFlag = true;
          this.singupError = err.error.email[0];
        }
      })
    } else if (this.selectedSubCat.length == 0) {
      this.singupError = 'Please Select Exam';
    } else {
      this.show3 = false;
      this.show4 = false;
      this.newUserFlag = true;
      this.singupError = 'Please enter valid Data';
    }
  }
}

@Component({
  selector: 'call-action',
  templateUrl: './call-action.html',
  styleUrls: ['./header.component.scss']
})

export class CallActionDialog {
  token: any;
  userData: any;

  constructor(public dialogRef: MatDialogRef<CallActionDialog>, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public dashboardService: HomeService, public deviceService: DeviceDetectorService, @Inject(DOCUMENT) public document: any,
    public router: Router) {
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }
  }


  addCallClickData(type: any) {
    let reqObj = {
      "examName": type,
      "count": 1
    }
    this.dashboardService.addCallClickData(reqObj).subscribe((res: any) => {

    })
  }

}


@Component({
  selector: 'certificate-action',
  templateUrl: './certificate.html',
  styleUrls: ['./header.component.scss']
})

export class certificateDialog {
  constructor(public dialogRef: MatDialogRef<certificateDialog>,) {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }




}